import { Link } from "react-router-dom";
import { InstallVideo } from "@/components/site/InstallVideo";
import { SwipeRow } from "@/components/site/SwipeRow";
import { HOW_STEPS } from "@/content/texts";

const Step = ({ s }) => (
  <article data-testid={`how-step-${s.n}`} className="flex h-full flex-col rounded-xl bg-white p-3 pb-6">
    <div className="overflow-hidden rounded-lg"><img data-testid={`how-step-${s.n}-image`} src={s.img} alt={s.alt} loading="lazy" className="aspect-[4/5] w-full object-cover" /></div>
    <div className="px-2 pt-5">
      <span className="font-serif-display text-4xl text-[#B18A4B]">{s.n}</span>
      <h3 className="mt-2 text-lg font-semibold">{s.title}</h3>
      <p className="mt-2 text-base leading-relaxed text-[#080808]/75">{s.text}</p>
      {s.extra && <p className="mt-2 text-sm text-[#080808]/60">{s.extra}</p>}
    </div>
  </article>
);

export const HowBlock = () => (
  <section data-testid="how-section" aria-labelledby="how-title" className="bg-[#EAE7E2]/60">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
      <h2 id="how-title" className="font-serif-display text-[28px] sm:text-[40px] font-medium leading-tight">Así funciona tu LUMINA</h2>
      <div className="mt-4 h-[2px] w-16 bg-[#B18A4B]" />
      <div className="mt-12">
        <SwipeRow testId="how-row" label="Pasos de LUMINA" items={HOW_STEPS} getKey={(s) => s.n} render={(s) => <Step s={s} />} />
      </div>
      <div data-testid="install-block" className="mx-auto mt-12 grid max-w-[900px] items-center gap-8 py-12 md:grid-cols-[1fr_auto] md:gap-12">
        <div>
          <h3 className="font-serif-display text-[28px] font-medium leading-tight sm:text-[36px]">Mira cómo se instala</h3>
          <div className="mt-4 h-[2px] w-12 bg-[#B18A4B]" />
          <p className="mt-5 max-w-md text-base leading-relaxed text-[#080808]/75">Ubica y fija los soportes en la pared, acerca tu lámina y el sistema magnético la sostiene, flotando.</p>
          <Link to="/como-funciona#guia" data-testid="how-guide-button"
            className="mt-8 hidden rounded-full border border-[#080808] px-7 py-3.5 text-[0.75rem] font-semibold uppercase tracking-[0.16em] transition-colors hover:bg-[#080808] hover:text-[#FAF8F4] md:inline-flex">
            Ver guía de instalación
          </Link>
        </div>
        <InstallVideo testId="home-install-video" className="justify-self-center" />
        <Link to="/como-funciona#guia" data-testid="how-guide-button-mobile"
          className="inline-flex justify-center rounded-full border border-[#080808] px-7 py-3.5 text-[0.75rem] font-semibold uppercase tracking-[0.16em] transition-colors hover:bg-[#080808] hover:text-[#FAF8F4] md:hidden">
          Ver guía de instalación
        </Link>
      </div>
    </div>
  </section>
);
